import React from "react";
import "./styles.css";

const WACC = () => {
  return (
    <div className="container">
      <h1>Weighted Average Cost of Capital (WACC)</h1>
      <p>The Weighted Average Cost of Capital (WACC) is a crucial metric in financial management, representing the average cost of capital for a company, weighted by the proportion of equity and debt in its capital structure. Let’s delve into what WACC is and how the tax rate plays a role.</p>
      <p>WACC is used as a discount rate in financial modeling and investment appraisal. It reflects the cost of both equity and debt, weighted by their respective proportions in the company’s capital structure.</p>
      <p><strong>Formula:</strong></p>
      <img src="assets/wacc.png" alt="WACC" />
      <p>Where:</p>
      <ul>
        <li><strong>E</strong> = Market value of equity</li>
        <li><strong>D</strong> = Market value of debt</li>
        <li><strong>Re</strong> = Cost of equity</li>
        <li><strong>Rd</strong> = Cost of debt</li>
        <li><strong>Tc</strong> = Tax rate</li>
      </ul>
      <h2>Tax Rate Considerations</h2>
      <p>The tax rate plays a significant role in financial calculations, particularly in WACC. Interest on debt is tax-deductible, which reduces the effective cost of debt. This is reflected in the WACC formula as <code>Rd × (1 - Tc)</code>. Similarly, the tax rate impacts cash flows in IRR and MIRR calculations, as after-tax cash flows are used to determine profitability.</p>
    </div>
  );
};

export default WACC;